import { Button } from '@/components/ui/button';
import { SignOut, ChartLine } from '@phosphor-icons/react';

const AdminHeader = ({ userName, onLogout }) => (
  <div className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200/50">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-slate-900 to-teal-600 rounded-lg flex items-center justify-center">
            <ChartLine size={24} weight="bold" className="text-white" />
          </div>
          <div>
            <div className="text-lg font-bold tracking-tight text-slate-900">Admin Dashboard</div>
            <div className="text-xs text-slate-600">Welcome, {userName || 'Admin'}</div>
          </div>
        </div>
        <Button onClick={onLogout} variant="outline" data-testid="logout-button">
          <SignOut size={20} className="mr-2" />
          Logout
        </Button>
      </div>
    </div>
  </div>
);

export default AdminHeader;
